import { default as styled } from 'styled-components';

import { fontHeadingOne, fontTextMdRegular } from '@/styles/helpers';

export const Text = styled.p`
  ${fontTextMdRegular};
  line-height: 2rem;
  text-align: center;
`;

export const Heading = styled.h1`
  ${fontHeadingOne};
  text-align: center;
`;
